import { IQuickActionsState } from './quickActions.types'
import { QuickActionsConstants } from './quickActions.constants'

export const initialQuickActionsState: IQuickActionsState = {
  quickActions: [],
  quickActionButtons: [],
  savedQuickActionButtons: [],
  savedQuickActionButtonsForNotification: [],
  localNotifications: [],
  localNotificationsToCancel: [],
  filteredQuickActionButtons: [],
  selectedQuickActionId: null,
  quickActionButtonRows: [],
  selectedQuickActionButtonId: null,
  addIntubationToTimeline: false,
  addMedicationToTimeline: false,
  addCardiacToTimeline: false,
  addDrainToTimeline: false,
  addAirwayToTimeline: false,
  addChildbirthOBToTimeline: false,
  addExtricationToTimeline: false,
  addHospitalNotifyToTimeline: false,
  addInitiateIVToTimeline: false,
  addImmobilizationToTimeline: false,
  addMedicalConsultToTimeline: false,
  addOperationsToTimeline: false,
  addRescueToTimeline: false,
  addBloodProductAdministrationToTimeline: false,
  addVentilatorToTimeline: false,
  addWoundCareToTimeline: false,
  addVentricularAssistDeviceToTimeline: false,
  addCriticalCareToTimeline: false,
  selectedQuickActionButton: {
    key: '',
    type: 'quickAction',
    procName: '',
    buttonCol: 1,
    buttonRow: 1,
    id: 0,
    maxTimes: 0,
    props: {
      hours: '',
      minutes: '',
      seconds: '',
      id: 0,
      title1: '',
      maxTimes: 0,
      timeToWarn: 0,
      buttonType: 0,
      quickActionPage: 0,
      buttonRow: 0,
      buttonCol: 0,
      procInfo: '',
      timesPressed: undefined,
      savedTime: 0,
      disabled: false,
    },
  },
  parentQuickActionLabel: '',
  mobileQuickActionButtonRows: [],
}

export function quickActionsReducer(
  state: IQuickActionsState = initialQuickActionsState,
  action: any
): IQuickActionsState {
  switch (action.type) {
    case QuickActionsConstants.SET_QUICK_ACTIONS:
      return { ...state, quickActions: action.quickActions }
    case QuickActionsConstants.SET_QUICK_ACTION_BUTTONS:
      return { ...state, quickActionButtons: action.quickActionButtons }
    case QuickActionsConstants.FILTER_QUICK_ACTION_BUTTONS:
      return { ...state, selectedQuickActionId: action.selectedQuickActionId }
    case QuickActionsConstants.SET_FILTERED_QUICK_ACTION_BUTTONS:
      return { ...state, filteredQuickActionButtons: action.filteredQuickActionButtons }
    case QuickActionsConstants.SET_QUICK_ACTION_BUTTON_ROWS:
      return { ...state, quickActionButtonRows: action.quickActionButtonRows }
    case QuickActionsConstants.SET_MOBILE_QUICK_ACTION_BUTTON_ROWS:
      return { ...state, mobileQuickActionButtonRows: action.mobileQuickActionButtonRows }
    case QuickActionsConstants.SET_SELECTED_QUICK_ACTION_BUTTON_ID:
      return { ...state, selectedQuickActionButtonId: action.payload }
    case QuickActionsConstants.SET_SELECTED_QUICK_ACTION_BUTTON:
      return { ...state, selectedQuickActionButton: action.selectedQuickActionButton }
    case QuickActionsConstants.SET_PARENT_QUICK_ACTION_LABEL:
      return { ...state, parentQuickActionLabel: action.parentQuickActionLabel }
    case QuickActionsConstants.SET_ADD_INTUBATION_TO_TIMELINE:
      return { ...state, addIntubationToTimeline: action.addIntubationToTimeline }
    case QuickActionsConstants.SET_ADD_AIRWAY_TO_TIMELINE:
      return { ...state, addAirwayToTimeline: action.addAirwayToTimeline }
    case QuickActionsConstants.SET_ADD_CHILDBIRTHOB_TO_TIMELINE:
      return { ...state, addChildbirthOBToTimeline: action.addChildbirthOBToTimeline }
    case QuickActionsConstants.SET_ADD_EXTRICATION_TO_TIMELINE:
      return { ...state, addExtricationToTimeline: action.addExtricationToTimeline }
    case QuickActionsConstants.SET_ADD_HOSPITAL_NOTIFY_TO_TIMELINE:
      return { ...state, addHospitalNotifyToTimeline: action.addHospitalNotifyToTimeline }
    case QuickActionsConstants.SET_ADD_INITIATE_IV_TO_TIMELINE:
      return { ...state, addInitiateIVToTimeline: action.addInitiateIVToTimeline }
    case QuickActionsConstants.SET_ADD_IMMOBILIZATION_TO_TIMELINE:
      return { ...state, addImmobilizationToTimeline: action.addImmobilizationToTimeline }
    case QuickActionsConstants.SET_ADD_MEDICAL_CONSULT_TO_TIMELINE:
      return { ...state, addMedicalConsultToTimeline: action.addMedicalConsultToTimeline }
    case QuickActionsConstants.SET_ADD_OPERATIONS_TO_TIMELINE:
      return { ...state, addOperationsToTimeline: action.addOperationsToTimeline }
    case QuickActionsConstants.SET_ADD_RESCUE_TO_TIMELINE:
      return { ...state, addRescueToTimeline: action.addRescueToTimeline }
    case QuickActionsConstants.SET_ADD_VENTILATOR_TO_TIMELINE:
      return { ...state, addVentilatorToTimeline: action.addVentilatorToTimeline }
    case QuickActionsConstants.SET_ADD_WOUND_CARE_TO_TIMELINE:
      return { ...state, addWoundCareToTimeline: action.addWoundCareToTimeline }
    case QuickActionsConstants.SET_ADD_MEDICATION_TO_TIMELINE:
      return { ...state, addMedicationToTimeline: action.addMedicationToTimeline }
    case QuickActionsConstants.SET_ADD_CARDIAC_TO_TIMELINE:
      return { ...state, addCardiacToTimeline: action.addCardiacToTimeline }
    case QuickActionsConstants.SET_ADD_DRAIN_TO_TIMELINE:
      return { ...state, addDrainToTimeline: action.addDrainToTimeline }
    case QuickActionsConstants.SET_ADD_VENTRICULAR_ASSIST_DEVICE_TO_TIMELINE:
      return { ...state, addVentricularAssistDeviceToTimeline: action.addVentricularAssistDeviceToTimeline }
    case QuickActionsConstants.SET_ADD_CRITICAL_CARE_TO_TIMELINE:
      return { ...state, addCriticalCareToTimeline: action.addCriticalCareToTimeline }
    case QuickActionsConstants.SET_SAVED_QUICK_ACTION_BUTTONS:
      return { ...state, savedQuickActionButtons: [...state.savedQuickActionButtons, action.selectedButton] }
    case QuickActionsConstants.SET_SAVED_QUICK_ACTION_BUTTONS_FOR_NOTIFICATION:
      return { ...state, savedQuickActionButtonsForNotification: action.savedQuickActionButtonsForNotification }
    case QuickActionsConstants.SET_LOCAL_NOTIFICATIONS:
      return { ...state, localNotifications: action.localNotifications }
    case QuickActionsConstants.SET_LOCAL_NOTIFICATIONS_TO_CANCEL:
      return { ...state, localNotificationsToCancel: action.localNotificationsToCancel }
    case QuickActionsConstants.RESET_LOCAL_NOTIFICATIONS_TO_CANCEL:
      return { ...state, localNotificationsToCancel: [] }
    case QuickActionsConstants.RESET_STATE:
      return {
        quickActions: [],
        quickActionButtons: [],
        savedQuickActionButtons: [],
        savedQuickActionButtonsForNotification: [],
        localNotifications: [],
        localNotificationsToCancel: [],
        filteredQuickActionButtons: [],
        selectedQuickActionId: null,
        quickActionButtonRows: [],
        selectedQuickActionButtonId: null,
        addIntubationToTimeline: false,
        addMedicationToTimeline: false,
        addCardiacToTimeline: false,
        addDrainToTimeline: false,
        addAirwayToTimeline: false,
        addChildbirthOBToTimeline: false,
        addExtricationToTimeline: false,
        addHospitalNotifyToTimeline: false,
        addInitiateIVToTimeline: false,
        addImmobilizationToTimeline: false,
        addMedicalConsultToTimeline: false,
        addOperationsToTimeline: false,
        addRescueToTimeline: false,
        addVentilatorToTimeline: false,
        addWoundCareToTimeline: false,
        addBloodProductAdministrationToTimeline: false,
        addVentricularAssistDeviceToTimeline: false,
        addCriticalCareToTimeline: false,
        selectedQuickActionButton: {
          key: '',
          type: 'quickAction',
          procName: '',
          buttonCol: 1,
          buttonRow: 1,
          id: 0,
          maxTimes: 0,
          props: {
            hours: '',
            minutes: '',
            seconds: '',
            id: 0,
            title1: '',
            maxTimes: 0,
            timeToWarn: 0,
            buttonType: 0,
            quickActionPage: 0,
            buttonRow: 0,
            buttonCol: 0,
            procInfo: '',
            timesPressed: undefined,
            savedTime: 0,
            disabled: false,
          },
        },
        parentQuickActionLabel: '',
        mobileQuickActionButtonRows: [],
      }
    default:
      return state
  }
}
